import { type ReactNode } from 'react';
import { UserActionEnum } from '@ev-tech/snowplow-library';

import { getPhoneLinkTrackingEventName } from '@/utils/tracking';
import { useExposeTracking } from '@/hooks/useExposeTracking';

type PhoneLinkProps = {
  trigger: string;
  index: number;
  phoneNumberCount: number;
  children: ReactNode;
};

export const PhoneLinkWrapper = ({ trigger, index, phoneNumberCount, children }: PhoneLinkProps) => {
  const { trackExposeUserInteractionEvent } = useExposeTracking();

  return (
    <div
      onClick={() =>
        trackExposeUserInteractionEvent({
          elementId: getPhoneLinkTrackingEventName(trigger, index, phoneNumberCount),
          action: UserActionEnum.call,
        })
      }
    >
      {children}
    </div>
  );
};
